import { useState } from 'react';
import { createVendor, updateVendor } from '../lib/vendors';
import { formatPhone } from '../utils/formatters';
import Modal from './Modal';

export default function VendorModal({mode, vendor, orgId, t, sb, si, onClose, onSaved, createAsPayee, settings}){
const[vf,setVf]=useState(()=>{
  if(mode==='edit'&&vendor)return{name:vendor.name||'',email_domain:vendor.email_domain||'',contact_name:vendor.contact_name||'',contact_email:vendor.contact_email||'',contact_phone:formatPhone(vendor.contact_phone||''),notes:vendor.notes||'',vendor_category:vendor.vendor_category||'inventory',default_expense_category:vendor.default_expense_category||''};
  return{name:'',email_domain:'',contact_name:'',contact_email:'',contact_phone:'',notes:'',vendor_category:createAsPayee?'expense':'inventory',default_expense_category:''};
});
const[vfErr,setVfErr]=useState('');
const[vfSaving,setVfSaving]=useState(false);

async function handleSave(){
  if(vfSaving)return;
  if(vf.vendor_category==='expense'&&!vf.default_expense_category){setVfErr('Pick a default expense category.');return;}
  setVfSaving(true);setVfErr('');
  try{
    let saved;
    const payload={...vf};
    if(vf.vendor_category!=='expense')payload.default_expense_category='';
    if(mode==='add')saved=await createVendor(orgId,payload);
    else saved=await updateVendor(vendor.id,payload);
    if(onSaved)onSaved(saved);
  }catch(e){setVfErr(e.message||'Could not save vendor');}
  setVfSaving(false);
}

const expCats=(settings?.expenseCategories||[]).sort();

return(
<Modal open={true} onClose={onClose} width={440} t={t}>
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
<div style={{fontSize:16,fontWeight:700}}>{mode==='add'?'Add Vendor':'Edit Vendor'}</div>
<button onClick={onClose} style={{background:'none',border:'none',color:t.tm,fontSize:18,cursor:'pointer',padding:4}}>✕</button>
</div>
<div style={{marginBottom:12}}><label style={{fontSize:9,color:vfErr&&!vf.name.trim()?t.ac:t.td,textTransform:'uppercase'}}>Name *</label><input value={vf.name} onChange={e=>setVf(p=>({...p,name:e.target.value}))} style={{...si,width:'100%'}} autoFocus/>{vfErr&&<div style={{fontSize:10,color:t.ac,marginTop:4}}>{vfErr}</div>}</div>

{/* Vendor category — 2-pill segmented control */}
<div style={{marginBottom:12}}>
<label style={{fontSize:9,color:t.td,textTransform:'uppercase',marginBottom:6,display:'block'}}>Vendor Type</label>
<div style={{display:'flex',gap:0,borderRadius:6,overflow:'hidden',border:`1px solid ${t.bd}`,width:'fit-content'}}>
{[['inventory','Inventory'],['expense','Expense']].map(([v,l])=><button key={v} onClick={()=>setVf(p=>({...p,vendor_category:v}))} style={{padding:'6px 16px',fontSize:11,fontWeight:vf.vendor_category===v?600:400,cursor:'pointer',border:'none',background:vf.vendor_category===v?t.bl:t.sf,color:vf.vendor_category===v?'#fff':t.tm,fontFamily:"'DM Sans',sans-serif"}}>{l}</button>)}
</div>
</div>

{/* Default expense category — only when expense */}
{vf.vendor_category==='expense'&&<div style={{marginBottom:12}}>
<label style={{fontSize:9,color:!vf.default_expense_category&&vfErr?t.ac:t.td,textTransform:'uppercase'}}>Default Expense Category *</label>
<select value={vf.default_expense_category} onChange={e=>setVf(p=>({...p,default_expense_category:e.target.value}))} style={{...si,width:'100%'}}>
<option value="">Select category...</option>
{expCats.map(c=><option key={c} value={c}>{c}</option>)}
</select>
<div style={{fontSize:9,color:t.td,marginTop:4}}>Auto-fills when this vendor's invoices are scanned. You can override per invoice.</div>
</div>}

<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
<div><label style={{fontSize:9,color:t.td,textTransform:'uppercase'}}>Email Domain</label><input value={vf.email_domain} onChange={e=>setVf(p=>({...p,email_domain:e.target.value}))} placeholder="example.com" style={{...si,width:'100%'}}/></div>
<div><label style={{fontSize:9,color:t.td,textTransform:'uppercase'}}>Contact Name</label><input value={vf.contact_name} onChange={e=>setVf(p=>({...p,contact_name:e.target.value}))} style={{...si,width:'100%'}}/></div>
</div>
<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
<div><label style={{fontSize:9,color:t.td,textTransform:'uppercase'}}>Contact Email</label><input value={vf.contact_email} onChange={e=>setVf(p=>({...p,contact_email:e.target.value}))} style={{...si,width:'100%'}}/></div>
<div><label style={{fontSize:9,color:t.td,textTransform:'uppercase'}}>Contact Phone</label><input value={vf.contact_phone} onChange={e=>setVf(p=>({...p,contact_phone:formatPhone(e.target.value)}))} placeholder="555-555-5555" style={{...si,width:'100%'}}/></div>
</div>
<div style={{marginBottom:16}}><label style={{fontSize:9,color:t.td,textTransform:'uppercase'}}>Notes</label><textarea value={vf.notes} onChange={e=>setVf(p=>({...p,notes:e.target.value}))} rows={3} style={{...si,width:'100%',resize:'vertical'}}/></div>
<div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
<button onClick={onClose} style={{...sb,background:t.sf,color:t.tm,border:`1px solid ${t.bd}`}}>Cancel</button>
<button onClick={handleSave} disabled={vfSaving||!vf.name.trim()} style={{...sb,background:t.gn,opacity:vf.name.trim()?1:0.4}}>{vfSaving?'Saving...':mode==='add'?'Add Vendor':'Save Changes'}</button>
</div>
</Modal>);
}
